import React from 'react';

export const TopDestinations = () => {
    return (
        <div>
            <h2>Top Destinations</h2>
        </div>
    );
};
